module.exports = __webpack_public_path__ + "static/media/zocalo2.5d047e2a.jpg";